import { analytics } from '@saucelabs/sl-util-axios';

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getBuildsTests(params) {
  return analytics.get('/trends/builds_tests', { params });
}

export function getTests(params) {
  return analytics.get('/tests', { params });
}
